import React from 'react';
import {EdapProvider} from '@homeaway/react-event-tracking';
import FilterBar from '../FilterBar/FilterBar';
import FilterForm from '../FilterForm/FilterForm';
import {ErrorReportBoundary} from '@homeaway/react-error-reporter';
import Experiment, {On, Off} from '@homeaway/react-experiment';
import {VRBO_WEB_SEARCH_NEW_FILTER_MENU} from '../../abacus/experiments';
import FilterBarV2 from '../FilterBarV2/FilterBarV2';
import MoreFiltersModal from '../MoreFiltersModal/MoreFiltersModal';

function FiltersContainer(props) {
    const {filterCountDataProvider: FilterCountDataProvider} = props;
    const eventcategory = {eventcategory: 'search'};

    return (
        <EdapProvider fields={eventcategory}>
            <ErrorReportBoundary
                name={'Filters threw an error'}
                // onError callback to hide any overlay (old experience) in case the component crashes
                onError={
                    /* istanbul ignore next */
                    () => props.hideOverlay && props.hideOverlay()
                }
            >
                <Experiment name={VRBO_WEB_SEARCH_NEW_FILTER_MENU}>
                    <On>
                        <FilterCountDataProvider
                            searchResultsLoading={props.searchResultsLoading}
                        >
                            {({filterGroups, resultsCount}) => {
                                const commonProps = {
                                    isMobile: props.isMobile,
                                    currency: props.currency,
                                    customFiltersParams: {
                                        selectedFilterByTotalPrice:
                                            props.inputFilterByTotalPrice,
                                        appliedFilterByTotalPrice:
                                            props.filterByTotalPrice,
                                        selectedMaxPrice: props.inputMaxPrice,
                                        selectedMinPrice: props.inputMinPrice,
                                        appliedMaxPrice: props.maxPrice,
                                        appliedMinPrice: props.minPrice,
                                        selectedMinBathrooms:
                                            props.inputMinBathrooms,
                                        selectedMinBedrooms:
                                            props.inputMinBedrooms,
                                        appliedMinBathrooms: props.minBathrooms,
                                        appliedMinBedrooms: props.minBedrooms,
                                    },
                                    selectedFilters: props.inputParams.filter,
                                    appliedFilters: props.params.filter,
                                    filterGroups,
                                    onCustomFilterUpdate:
                                        props.updateInputParams,
                                    onFilterToggle: props.updateFilterCheck,
                                    onMultipleFilterToggle:
                                        props.updateMultipleFilterCheck,
                                    onDone: props.filter,
                                    onClear: props.clearFilters,
                                    onDismiss: props.syncInputParams,
                                    priceFilterOptions:
                                        props.priceFilterOptions,
                                    priceInputValuesAreValid:
                                        props.priceInputValuesAreValid,
                                    updatePriceInputValuesValidity:
                                        props.updatePriceInputValuesValidity,
                                    results: resultsCount,
                                };

                                if (props.allFiltersButtonOnly) {
                                    return (
                                        <MoreFiltersModal
                                            {...commonProps}
                                            id="all-filters"
                                            sliceAt={0}
                                            allFiltersButtonCustomTrigger={
                                                props.allFiltersButtonCustomTrigger
                                            }
                                        />
                                    );
                                }

                                return <FilterBarV2 {...commonProps} />;
                            }}
                        </FilterCountDataProvider>
                    </On>
                    <Off>
                        {props.isMobile ? (
                            <FilterForm {...props} />
                        ) : (
                            <FilterBar {...props} />
                        )}
                    </Off>
                </Experiment>
            </ErrorReportBoundary>
        </EdapProvider>
    );
}

export default FiltersContainer;
export {FiltersContainer as Filters};
